import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// One accordion section of the desktop left pane, shared by the member and
// guest room views so the section styling can't drift between them.
export default function LeftPaneSection({ title, id, defaultExpanded = true, children }) {
    return (
        <Accordion defaultExpanded={defaultExpanded} disableGutters sx={{ flexShrink: 0 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} id={id}>
                <Typography>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>{children}</AccordionDetails>
        </Accordion>
    );
}
